import type { FaireProductEntity } from "../../entity_types/product";

export const p_8kvpxefxba: FaireProductEntity = {
  token: "p_8kvpxefxba",
  type: "product",
  name: "100% All-Natural Original Garlic Chip Chili Sauce -Topping !",
  brandToken: "b_w5tmkmaxbm",
  brandName: "SAUCE UP NEW YORK",
  imageUrl:
    "https://cdn.faire.com/fastly/5006ad4de6616a5203d41ca9cde7602e896a6bf940683e26d661655acf9bf17e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c4f8aa961c5f866e0daa2b557ff1b5085f3960331052721bc66591a37855c8d4.jpeg",
    "https://cdn.faire.com/fastly/cc6fb491bbd3dbd21e70008fe89e3db6c4cc9ad8259652fe64d20f44b4723784.jpeg",
    "https://cdn.faire.com/fastly/62b7aa2aea1b8be52d71fa72efae5a77b1d9c3da00083a0a6c3c3ed03d10f862.jpeg",
    "https://cdn.faire.com/fastly/3ba1d6e077d6e4c4e1b8feb34ea84e8bb66e9db8d955e936e1d8ff463a64bb8b.jpeg",
    "https://cdn.faire.com/fastly/971015503adc401a40c5beafe89ebdcc86cc7f417eb21d209b69c3c921d367f4.jpeg",
    "https://cdn.faire.com/fastly/fd80730c093e2cd2761059f6412e76c3a23fc5b852f91ead99b44665a85f8dec.jpeg",
    "https://cdn.faire.com/fastly/1f86cc541e96f3c2769724249315bd05d9bb0e35ad9cc53259c391c877270c3f.jpeg",
    "https://cdn.faire.com/fastly/8170be288225d9161515e968d8a6bdf5492468ef77899e45854acb151316ecf3.jpeg",
  ],
  priceDollars: 8.5,
  description:
    "Introducing our 100% all-natural garlic chip chili sauce (original), a culinary masterpiece that combines the rich flavors of fried garlic chips, fried shallots, Mexican chilies, premium chef-blend spices, and a touch of honey. This sauce is a flavor bomb that is keto-friendly, gluten-free, and free from MSG and GMOs. Mildly hot with a delightful crunch and chewiness, this sauce strikes the perfect balance between sweet and savory. Experience the artisanal craftsmanship in every jar of our garlic chip chili sauce.\n\n𝐅𝐞𝐚𝐭𝐮𝐫𝐞𝐬:\n• 100% all-natural ingredients\n• Keto-friendly and gluten-free\n• No MSG or GMOs\n• Mildly hot with a delightful crunch\n• Perfect balance of sweet and savory\n• Versatile topping for various dishes\n• Made with premium chef-blend spices\n• Contains fried garlic chips, fried shallots, Mexican chilies, and honey\n\nPeople also searching for: chili sauce, garlic sauce, all-natural sauces, gourmet toppings, spicy condiments",
  tags: [],
  msrpDollars: 13.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:47:13.179Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
